// Maps a meeting's stored MeetingStatus + scheduled date to the 5-state
// MeetingDerivedStatus used for display. Held / cancelled are terminal —
// they never flip. Scheduled splits into overdue (date in the past),
// due-soon (today through +7 days), or scheduled (further out).

import type { MeetingDerivedStatus, MeetingStatus } from "../../../../types";

function daysBetweenUTC(from: Date, toIso: string): number {
  const a = Date.UTC(
    from.getUTCFullYear(),
    from.getUTCMonth(),
    from.getUTCDate(),
  );
  const due = new Date(`${toIso}T00:00:00Z`);
  const b = Date.UTC(
    due.getUTCFullYear(),
    due.getUTCMonth(),
    due.getUTCDate(),
  );
  return Math.round((b - a) / 86_400_000);
}

export function deriveMeetingStatus(
  status: MeetingStatus,
  date: string,
  today: Date = new Date(),
): MeetingDerivedStatus {
  if (status === "held" || status === "cancelled") return status;
  const days = daysBetweenUTC(today, date);
  if (days < 0) return "overdue";
  if (days <= 7) return "due-soon";
  return "scheduled";
}
